import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/corporate/recruit-image.png'
import _imports_1 from '@/assets/images/corporate/vector.svg'


const _hoisted_1 = {
  id: "recruit",
  class: "recruit-section"
}
const _hoisted_2 = { class: "recruit-content" }
const _hoisted_3 = { class: "recruit-btn" }
const _hoisted_4 = { class: "dialog-content" }

import { ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CorporateRecruit',
  setup(__props) {

const showDialog = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "section-bg-top" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"section-header\" data-v-33523986><h2 class=\"section-title\" data-v-33523986>Recruit</h2><p class=\"section-subtitle\" data-v-33523986>採用</p></div><div class=\"recruit-image\" data-v-33523986><img src=\"" + _imports_0 + "\" alt=\"採用イメージ\" data-v-33523986></div><h3 class=\"recruit-catch\" data-v-33523986>暮らしに寄り添う仕事を一緒に</h3><div class=\"recruit-text\" data-v-33523986><p data-v-33523986>採用情報はこちらからご覧いただけます。</p><p data-v-33523986>現在、各職種でスタッフを募集しています。</p></div>", 4)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "recruit-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showDialog.value = true))
        }, _cache[3] || (_cache[3] = [
          _createElementVNode("span", null, "採用情報を見る", -1),
          _createElementVNode("span", { class: "arrow-circle" }, [
            _createElementVNode("img", {
              src: _imports_1,
              alt: ""
            })
          ], -1)
        ]))
      ])
    ]),
    (showDialog.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "dialog-overlay",
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (showDialog.value = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "dialog-icon" }, "🚧", -1)),
            _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "dialog-title" }, "準備中", -1)),
            _cache[7] || (_cache[7] = _createElementVNode("p", { class: "dialog-text" }, [
              _createTextVNode(" 採用情報ページは現在準備中です。"),
              _createElementVNode("br"),
              _createTextVNode(" もうしばらくお待ちください。 ")
            ], -1)),
            _createElementVNode("button", {
              type: "button",
              class: "dialog-close-btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (showDialog.value = false))
            }, " 閉じる ")
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})